export default __webpack_public_path__ + "static/media/na.c98ec4d4.svg";